const LABELS = {
    // Navigation & App
    'jupas_advisor': { 'en': 'JUPAS Analyser', 'zh': '聯招幫幫' },
    'home': { 'en': 'Home', 'zh': '主頁' },
    'recommended': { 'en': 'Recommended', 'zh': '推薦' },
    'highlyRecommended': { 'en': 'Highly Recommended', 'zh': '強烈推薦' },
    'recommendedLabel': { 'en': 'Recommended', 'zh': '推薦' },
    'worthConsidering': { 'en': 'Worth Considering', 'zh': '值得考慮' },
    'priorities': { 'en': 'Priorities', 'zh': '優先次序' },
    'favourites': { 'en': 'Favourites', 'zh': '喜愛課程' },
    'sign-in': { 'en': 'Sign In', 'zh': '登入' },
    'sign-out': { 'en': 'Sign Out', 'zh': '登出' },
    'signingIn': { 'en': 'Signing you in...', 'zh': '正在為你登入...' },
    'signingOut': { 'en': 'Signing you out...', 'zh': '正在為你登出...' },
    'signInProgress': { 'en': 'Preparing Google sign-in. Please wait while account selection opens.', 'zh': '正在準備 Google 登入，請稍候以選擇帳戶。' },
    'signOutProgress': { 'en': 'Clearing this device and waiting for sign-out confirmation.', 'zh': '正在清除此裝置上的資料，並等待登出確認。' },
    'signInConfirm': { 'en': 'Your current local data will be replaced with your saved cloud data. Continue?', 'zh': '你的本地數據將會被雲端保存的數據取代。繼續？' },
    'signOutConfirm': { 'en': 'This will clear your saved selections before signing out. Continue?', 'zh': '這將會在登出前清除你已儲存的選擇。繼續？' },

    // Sign-in gate: Recommendations, Favourites and Priorities are for signed-in users only
    'signInRequired': { 'en': 'Sign in required', 'zh': '需要登入' },
    'featureLoggedInOnly': { 'en': 'This feature is only available to logged-in users.', 'zh': '此功能只供已登入用戶使用。' },
    'signInRequiredRecommended': { 'en': 'Sign in or sign up to get personalised programme recommendations, saved to your account.', 'zh': '請登入或註冊，以獲取個人化課程推薦，並儲存至你的帳戶。' },
    'signInRequiredFavourites': { 'en': 'Sign in or sign up to save programmes to your account.', 'zh': '請登入或註冊，以將課程儲存至你的帳戶。' },
    'signInRequiredPriorities': { 'en': 'Sign in or sign up to plan and save your programme order.', 'zh': '請登入或註冊，以編排並儲存你的課程次序。' },
    'scoreQuartileFilters': { 'en': 'Score quartile filters', 'zh': '收生成績四分位篩選' },
    'signInRequiredScoreQuartileFilters': { 'en': 'Sign in to filter programmes by your score against their admission quartiles.', 'zh': '登入以按你的分數與課程收生成績四分位數篩選課程。' },
    'signInToContinue': { 'en': 'Sign in to continue', 'zh': '登入以繼續' },
    'clear-selections': { 'en': 'Clear All Selections', 'zh': '清除所有選擇' },
    'clear-selections-confirm': { 'en': 'Clear all preferences and favourites?', 'zh': '清除所有設定和最愛課程？' },
    'debugResults': { 'en': 'Debug Results', 'zh': '調試結果' },
    'redrawResults': { 'en': 'Redraw Results', 'zh': '重繪結果' },
    'yes': { 'en': 'Yes', 'zh': '是' },
    'no': { 'en': 'No', 'zh': '否' },

    // Home page
    'eligible-tab': { 'en': 'Eligible', 'zh': '符合要求' },
    // 'ger': {'en':'General Entrance Requirements', 'zh':'一般入學要求'},
    // 'per': {'en':'Programme Entrance Requirements', 'zh':'課程入學要求'},

    'ger': { 'en': 'GER', 'zh': 'GER' },
    'per': { 'en': 'PER', 'zh': 'PER' },

    'eligible': { 'en': 'Met', 'zh': '符合' },
    'ineligible': { 'en': 'Not Met', 'zh': '不符合' },

    'programmes': { 'en': 'Programmes', 'zh': '課程' },
    'all': { 'en': 'All', 'zh': '全部' },
    'search': { 'en': 'Search', 'zh': '搜尋' },
    'searchProgrammes': { 'en': 'Search programmes...', 'zh': '搜尋課程...' },
    'sortByLikelihood': { 'en': 'Sort by Likelihood', 'zh': '按錄取機會排序' },
    'sortByJupasId': { 'en': 'Sort by JUPAS ID', 'zh': '按 JUPAS 編號排序' },
    'sortByProgrammeName': { 'en': 'Sort by Programme Name', 'zh': '按課程名稱排序' },
    'sortByJupasIdCompact': { 'en': 'JUPAS ID', 'zh': 'JUPAS 編號' },
    'sortByProgrammeNameCompact': { 'en': 'Programme', 'zh': '課程' },
    'filterLowerQuartile': { 'en': 'Lower Quartile', 'zh': '下四分位數' },
    'filterUpperQuartile': { 'en': 'Upper Quartile', 'zh': '上四分位數' },
    'myScoreAtLeast': { 'en': 'My score ≥', 'zh': '我的分數 ≥' },
    'scoreQuartileRangeDescription': { 'en': 'Select the range of admission scores to include in the results.', 'zh': '選擇要在結果中顯示的收生成績範圍。' },
    'apply': { 'en': 'Apply', 'zh': '套用' },
    'filters': { 'en': 'Filters', 'zh': '篩選' },
    'clearFilters': { 'en': 'Clear Filters', 'zh': '清除篩選' },
    'selectUniversity': { 'en': 'Select University', 'zh': '選擇大學' },
    'selectDiscipline': { 'en': 'Select Discipline', 'zh': '選擇學科範疇' },

    // Home page - DSE section
    'dseResults': { 'en': 'DSE Results', 'zh': 'DSE 成績' },
    'enterScoresDescription': { 'en': 'Enter your current score, minimum expected score, and maximum expected score', 'zh': '輸入你的現時成績、最低預期成績及最高預期成績' },
    'autoPopulateMinMax': { 'en': 'Auto Populate Min & Max', 'zh': '自動填入最低及最高分數' },
    'resetMinMax': { 'en': 'Reset Min & Max', 'zh': '重設最低及最高分數' },
    'saveAsImage': { 'en': 'Save as Image', 'zh': '儲存為圖片' },
    'selectElectives': { 'en': 'Select Electives', 'zh': '選擇選修科目' },
    'subject': { 'en': 'Subject', 'zh': '科目' },
    'selectGrade': { 'en': 'Select grade', 'zh': '選擇成績' },
    'min': { 'en': 'Min', 'zh': '最低' },
    'max': { 'en': 'Max', 'zh': '最高' },
    'sameAsCurrent': { 'en': 'Same as current', 'zh': '與現時成績相同' },
    'calculate': { 'en': 'Calculate', 'zh': '計算' },
    'calculateToSeeResults': { 'en': 'Click "Calculate" to see programme results', 'zh': '點擊「計算」以查看課程結果' },
    'enterGradesToCalculate': { 'en': 'Enter grades to calculate scores', 'zh': '輸入成績以計算分數' },

    // Programme Results Table
    'programmeResults': { 'en': 'Programme Results', 'zh': '課程結果' },
    'yourCurrentScore': { 'en': 'Your Current Score', 'zh': '你的現時分數' },

    'currentLevel': { 'en': 'Current Level', 'zh': '現時成績' },
    'yourLevels': { 'en': 'Your Levels', 'zh': '你的成績' },

    'lowerScore2025': { 'en': '2025 Lower Score', 'zh': '2025下四分位數' },
    'medianScore2025': { 'en': '2025 Median Score', 'zh': '2025中位數' },
    'upperScore2025': { 'en': '2025 Upper Score', 'zh': '2025上四分位數' },
    'eng': { 'en': 'Eng', 'zh': '英文' },
    'chin': { 'en': 'Chin', 'zh': '中文' },
    'math': { 'en': 'Math', 'zh': '數學' },
    'csd': { 'en': 'CSD', 'zh': '公社' },
    'm1': { 'en': '(M1)', 'zh': '(M1)' },
    'elective1': { 'en': 'Elective 1', 'zh': '選修1' },
    'elective2': { 'en': 'Elective 2', 'zh': '選修2' },
    'elective3': { 'en': 'Elective 3', 'zh': '選修3' },
    'elective4': { 'en': 'Elective 4', 'zh': '選修4' },
    'elective5': { 'en': 'Elective 5', 'zh': '選修5' },
    'comments': { 'en': 'Comments', 'zh': '備註' },
    'programmeName': { 'en': 'Programme Name', 'zh': '課程名稱' },
    'jupas_id': { 'en': 'JUPAS No.', 'zh': '聯招編號' },
    'signInWithGoogle': { 'en': 'Sign in with Google', 'zh': '以Google登入' },
    'signInWithEmail': { 'en': 'Sign in with Email', 'zh': '以電郵登入' },
    'orSignInWithEmail': { 'en': 'or sign in with email', 'zh': '或以電郵登入' },
    'orSignInWithGoogle': { 'en': 'or sign in with Google', 'zh': '或以Google登入' },
    'emailAddress': { 'en': 'Email address', 'zh': '電郵地址' },
    'sendCode': { 'en': 'Send Code', 'zh': '發送驗證碼' },
    'sendingCode': { 'en': 'Sending...', 'zh': '正在發送...' },
    'verificationCode': { 'en': 'Verification code', 'zh': '驗證碼' },
    'verifyAndSignIn': { 'en': 'Verify & Sign In', 'zh': '驗證並登入' },
    'verifying': { 'en': 'Verifying...', 'zh': '正在驗證...' },
    'codeSentTo': { 'en': 'Code sent to', 'zh': '驗證碼已發送至' },
    'changeEmail': { 'en': 'Change email', 'zh': '更改電郵' },
    'resendCode': { 'en': 'Resend code', 'zh': '重新發送驗證碼' },
    'signUp': { 'en': 'Sign up', 'zh': '註冊' },
    'signInNotConfigured': { 'en': 'Sign-in is not set up on this server yet. Please contact the site administrator — retrying will not help.', 'zh': '此伺服器尚未設定登入功能。請聯絡網站管理員，重試並不會解決問題。' },
    'signInFailedRetry': { 'en': 'Sign-in failed. Please try again.', 'zh': '登入失敗，請再試一次。' },
    'signUpDescription': { 'en': 'Enter your email and we will send you a six-digit verification code.', 'zh': '輸入你的電郵，我們會發送六位數字驗證碼給你。' },
    'signUpOtpDescription': { 'en': 'Enter the six-digit code we emailed you to finish signing in.', 'zh': '輸入我們電郵給你的六位數字驗證碼以完成登入。' },
    'signUpOrSignIn': { 'en': 'Sign up / Sign in', 'zh': '註冊 / 登入' },
    'schoolInstitution': { 'en': 'School / Institution Full Name', 'zh': '學校／院校全名' },
    'schoolInstitutionPlaceholder': { 'en': 'e.g. Queen Elizabeth School', 'zh': '例如：伊利沙伯中學' },
    'countryRegion': { 'en': 'Country/Region', 'zh': '國家／地區' },
    'countryRegionPlaceholder': { 'en': 'e.g. Hong Kong', 'zh': '例如：香港' },
    'optionalField': { 'en': 'Optional', 'zh': '選填' },
    'requiredFieldsNote': { 'en': 'Required fields', 'zh': '必填欄位' },
    'profilePromptTitle': { 'en': 'Tell us where you study', 'zh': '請告訴我們你就讀的學校' },
    'profilePromptDescription': { 'en': 'Adding your school or institution helps us improve JUPAS Analyser. This is optional — you can skip it.', 'zh': '提供你的學校或院校有助我們改善聯招幫幫。此欄選填，你可以略過。' },
    'skipForNow': { 'en': 'Skip for now', 'zh': '暫時略過' },
    'save': { 'en': 'Save', 'zh': '儲存' },
    'saving': { 'en': 'Saving...', 'zh': '儲存中...' },
    'profileSaveFailed': { 'en': 'Could not save. Please try again.', 'zh': '無法儲存，請再試一次。' },

    // Anonymous session timeout (requirement 1b)
    'sessionExpiredTitle': { 'en': 'Session timed out', 'zh': '工作階段已逾時' },
    'sessionExpiredBody': { 'en': 'You were away for over an hour. Because you are not signed in, nothing you entered is kept on this device, so this session has been cleared. Sign in if you would like your details remembered next time.', 'zh': '你已離開超過一小時。由於你未有登入，你輸入的資料不會儲存在此裝置上，因此此工作階段已被清除。如希望下次記住你的資料，請登入。' },
    'sessionExpiredAction': { 'en': 'Start again', 'zh': '重新開始' },
    'loading': { 'en': 'Loading...', 'zh': '載入中...' },
    'selectYourElectiveSubjects': { 'en': 'Select Your Elective Subjects', 'zh': '選擇你的選修科目' },
    'chooseYourElectives': { 'en': 'Choose your elective subjects in addition to the core subjects.', 'zh': '除核心科目外，選擇你的個選修科目。' },
    'electivesSelected': { 'en': 'Electives Selected', 'zh': '已選選修科' },
    'addNewElectiveSubject': { 'en': 'Add a new elective subject:', 'zh': '新增選修科目：' },
    'searchAndSelectSubject': { 'en': 'Search and select a subject...', 'zh': '搜尋並選擇科目...' },
    'noSubjectsAvailable': { 'en': 'No subjects available', 'zh': '沒有可選科目' },
    'noSubjectsFoundMatching': { 'en': 'No subjects found matching', 'zh': '找不到符合以下條件的科目' },
    'categoryShort': { 'en': 'Cat', 'zh': '類別' },
    'youHaveSelectedMaximum': { 'en': 'You have selected the maximum of 6 elective subjects', 'zh': '你已選擇最多6個選修科目' },
    'done': { 'en': 'Done', 'zh': '完成' },
    'cancel': { 'en': 'Cancel', 'zh': '取消' },
    'unsavedChanges': { 'en': 'Unsaved Changes', 'zh': '未保存的更改' },
    'electiveChangesWillBeLost': { 'en': 'Your elective selection changes will be lost. Are you sure?', 'zh': '你的選修科目選擇將會丟失。確定嗎？' },
    'yesDiscard': { 'en': 'Yes, discard', 'zh': '是，放棄' },
    'keepEditing': { 'en': 'Keep editing', 'zh': '繼續編輯' },
    'commerce': { 'en': 'Commerce', 'zh': '商業' },
    'arts': { 'en': 'Arts', 'zh': '藝術' },
    'language': { 'en': 'Language', 'zh': '語言' },

    // DSE Subject badges
    'core': { 'en': 'Core', 'zh': '核心' },
    'elective': { 'en': 'Elective', 'zh': '選修' },
    'attained': { 'en': 'Attained', 'zh': '達標' },
    'unattained': { 'en': 'Unattained', 'zh': '未達標' },
    'Attained': { 'en': 'Attained', 'zh': '達標' },
    'Unattained': { 'en': 'Unattained', 'zh': '未達標' },
    'tableTotal': { 'en': 'Total', 'zh': '總分' },

    // Core Subjects
    'chineseLanguage': { 'en': 'Chinese Language', 'zh': '中國語文' },
    'englishLanguage': { 'en': 'English Language', 'zh': '英國語文' },
    'mathematics': { 'en': 'Mathematics', 'zh': '數學' },
    'citizenshipSocialDevelopment': { 'en': 'Citizenship and Social Development', 'zh': '公民與社會發展' },


    // Subject button labels (abbreviated forms for UI)
    'subject_physics': { 'en': 'Physics', 'zh': '物理' },
    'subject_chemistry': { 'en': 'Chemistry', 'zh': '化學' },
    'subject_biology': { 'en': 'Biology', 'zh': '生物' },
    'subject_ict': { 'en': 'ICT', 'zh': '資訊及通訊科技' },
    'subject_designTech': { 'en': 'Design & Tech', 'zh': '設計與應用科技' },
    'subject_mathsM1': { 'en': 'Maths (M1)', 'zh': '數學（M1）' },
    'subject_mathsM2': { 'en': 'Maths (M2)', 'zh': '數學（M2）' },
    'subject_chineseHistory': { 'en': 'Chinese History', 'zh': '中國歷史' },
    'subject_history': { 'en': 'History', 'zh': '歷史' },
    'subject_geography': { 'en': 'Geography', 'zh': '地理' },
    'subject_economics': { 'en': 'Economics', 'zh': '經濟' },
    'subject_ethicsReligion': { 'en': 'Ethics & Religion', 'zh': '倫理與宗教' },
    'subject_chineseLiterature': { 'en': 'Chinese Literature', 'zh': '中國文學' },
    'subject_englishLiterature': { 'en': 'English Literature', 'zh': '英語文學' },
    'subject_visualArts': { 'en': 'Visual Arts', 'zh': '視覺藝術' },
    'subject_music': { 'en': 'Music', 'zh': '音樂' },
    'subject_bafs': { 'en': 'BAFS', 'zh': '企業、會計與財務概論' },
    'subject_pe': { 'en': 'PE', 'zh': '體育' },
    'subject_healthSocialCare': { 'en': 'Health & Social Care', 'zh': '健康管理與社會關懷' },
    'subject_tourismHospitality': { 'en': 'Tourism & Hospitality', 'zh': '旅遊與款待' },
    'subject_technologyLiving': { 'en': 'Technology & Living', 'zh': '科技與生活' },
    'subject_frenchLanguage': { 'en': 'French Language', 'zh': '法語' },
    'subject_germanLanguage': { 'en': 'German Language', 'zh': '德語' },
    'subject_japaneseLanguage': { 'en': 'Japanese Language', 'zh': '日語' },
    'subject_koreanLanguage': { 'en': 'Korean Language', 'zh': '韓語' },
    'subject_spanishLanguage': { 'en': 'Spanish Language', 'zh': '西班牙語' },
    'subject_urduLanguage': { 'en': 'Urdu Language', 'zh': '烏爾都語' },

    // Additional subject keys (full names for HomePage)
    'subject_chineseLanguage': { 'en': 'Chinese Language', 'zh': '中國語文' },
    'subject_englishLanguage': { 'en': 'English Language', 'zh': '英國語文' },
    'subject_mathematics': { 'en': 'Mathematics', 'zh': '數學' },
    'subject_citizenshipAndSocialDevelopment': { 'en': 'Citizenship and Social Development', 'zh': '公民與社會發展' },
    'subject_physicalEducation': { 'en': 'Physical Education', 'zh': '體育' },
    'subject_designAndAppliedTechnology': { 'en': 'Design and Applied Technology', 'zh': '設計與應用科技' },
    'subject_healthManagementAndSocialCare': { 'en': 'Health Management and Social Care', 'zh': '健康管理與社會關懷' },
    'subject_informationAndCommunicationTechnology': { 'en': 'Information and Communication Technology', 'zh': '資訊及通訊科技' },
    'subject_technologyAndLiving': { 'en': 'Technology and Living', 'zh': '科技與生活' },
    'subject_combinedScience': { 'en': 'Combined Science', 'zh': '組合科學' },
    'subject_mathematicsExtendedPartModule1': { 'en': 'Mathematics Extended Part Module 1', 'zh': '數學延伸部分單元一' },
    'subject_mathematicsExtendedPartModule2': { 'en': 'Mathematics Extended Part Module 2', 'zh': '數學延伸部分單元二' },
    'subject_ethicsAndReligiousStudies': { 'en': 'Ethics and Religious Studies', 'zh': '倫理與宗教' },
    'subject_businessAccountingAndFinancialStudies': { 'en': 'Business, Accounting and Financial Studies', 'zh': '企業、會計與財務概論' },
    'subject_tourismAndHospitalityStudies': { 'en': 'Tourism and Hospitality Studies', 'zh': '旅遊與款待' },
    'subject_culturalAndCreativeProductDesign': { 'en': 'Cultural and Creative Product Design', 'zh': '文化及創意產品設計' },
    'subject_interiorAndExhibitionDesignInteriorAndEventSpatialDesign': { 'en': 'Interior and Exhibition Design/Interior and Event Spatial Design', 'zh': '室內及展覽設計/室內及活動空間設計' },
    'subject_interiorAndExhibitionDesign': { 'en': 'Interior and Exhibition Design', 'zh': '室內及展覽設計' },
    'subject_jewelleryDesignInDigitalAge': { 'en': 'Jewellery Design in Digital Age', 'zh': '數碼時代的珠寶設計' },
    'subject_computerGameAndAnimationDesign': { 'en': 'Computer Game and Animation Design', 'zh': '電腦遊戲及動畫設計' },
    'subject_digitalComicDesignAndProduction': { 'en': 'Digital Comic Design and Production', 'zh': '數碼漫畫設計及製作' },
    'subject_takingAChanceOnDance': { 'en': 'Taking a Chance on Dance', 'zh': '舞動人生' },
    'subject_theEssentialsOfTheatreArts': { 'en': 'The Essentials of Theatre Arts', 'zh': '劇場藝術導論' },
    'subject_digitalMediaAndRadioProduction': { 'en': 'Digital Media and Radio Production', 'zh': '數碼媒體及電台廣播製作' },
    'subject_filmAndTransmediaFilmProduction': { 'en': 'Film and Transmedia/Film Production', 'zh': '電影及跨媒體/電影製作' },
    'subject_filmAndTransmedia': { 'en': 'Film and Transmedia', 'zh': '電影及跨媒體' },
    'subject_digitalBrandCommunicationDigitalAdvertising': { 'en': 'Digital Brand Communication/Digital Advertising', 'zh': '數碼品牌傳播/數碼廣告' },
    'subject_digitalBrandCommunication': { 'en': 'Digital Brand Communication', 'zh': '數碼品牌傳播' },
    'subject_prAndMultimediaCommunication': { 'en': 'PR and Multimedia Communication', 'zh': '公關及多媒體傳訊' },
    'subject_airportPassengerTerminalOperationsAirportOperationsAndServices': { 'en': 'Airport Passenger Terminal Operations/Airport Operations and Services', 'zh': '機場客運大樓運作/機場運作及服務' },
    'subject_gerontechAndServices': { 'en': 'Gerontech and Services', 'zh': '樂齡科技及服務' },
    'subject_foodTechnologyAndNutrition': { 'en': 'Food Technology and Nutrition', 'zh': '食品科技及營養學' },
    'subject_foundationInChineseMedicine': { 'en': 'Foundation in Chinese Medicine', 'zh': '中醫學基礎' },
    'subject_petCareAndGrooming': { 'en': 'Pet Care and Grooming', 'zh': '寵物護理及美容' },
    'subject_exerciseAndFitnessCoaching': { 'en': 'Exercise and Fitness Coaching', 'zh': '運動及體適能教練' },
    'subject_exerciseScienceAndHealthFitness': { 'en': 'Exercise Science and Health Fitness', 'zh': '運動科學及健康體適能' },
    'subject_electricalAndEnergyEngineering': { 'en': 'Electrical and Energy Engineering', 'zh': '電機及能源工程' },
    'subject_aiAndRobotics': { 'en': 'AI and Robotics', 'zh': '人工智能及機械人' },
    'subject_esportsTechnologyAndManagement': { 'en': 'eSports Technology and Management', 'zh': '電競科技及管理' },

    // Category A, B, C - top-level categories
    'categoryA': { 'en': 'Category A: Senior Secondary Subjects', 'zh': '甲類：高中科目' },
    'categoryB': { 'en': 'Category B: Applied Learning Subjects', 'zh': '乙類：應用學習科目' },
    'categoryC': { 'en': 'Category C: Other Language Subjects', 'zh': '丙類：其他語言科目' },

    // Category B - Applied Learning Subject Categories
    'subject_appliedLearningCreativeStudies': { 'en': 'Applied Learning - Creative Studies', 'zh': '應用學習 - 創意學習' },
    'subject_appliedLearningMediaCommunication': { 'en': 'Applied Learning - Media & Communication', 'zh': '應用學習 - 媒體及傳意' },
    'subject_appliedLearningBusinessManagementLaw': { 'en': 'Applied Learning - Business, Management & Law', 'zh': '應用學習 - 商業、管理及法律' },
    'subject_appliedLearningServices': { 'en': 'Applied Learning - Services', 'zh': '應用學習 - 服務' },
    'subject_appliedLearningAppliedScience': { 'en': 'Applied Learning - Applied Science', 'zh': '應用學習 - 應用科學' },
    'subject_appliedLearningEngineeringProduction': { 'en': 'Applied Learning - Engineering & Production', 'zh': '應用學習 - 工程及生產' },

    // Category B - Applied Learning Individual Subjects
    // Creative Studies
    'subject_creativeStudies': { 'en': 'Creative Studies', 'zh': '創意學習' },
    'subject_culturalCreativeProductDesign': { 'en': 'Cultural and Creative Product Design', 'zh': '文化及創意產品設計' },
    'subject_fashionImageDesign': { 'en': 'Fashion Image Design', 'zh': '時裝形象設計' },
    'subject_interiorExhibitionDesign': { 'en': 'Interior and Exhibition Design/Interior and Event Spatial Design', 'zh': '室內及展覽設計/室內及活動空間設計' },
    'subject_jewelleryDesignDigitalAge': { 'en': 'Jewellery Design in Digital Age', 'zh': '數碼時代的珠寶設計' },
    'subject_computerGameAnimationDesign': { 'en': 'Computer Game and Animation Design', 'zh': '電腦遊戲及動畫設計' },
    'subject_digitalComicDesignProduction': { 'en': 'Digital Comic Design and Production', 'zh': '數碼漫畫設計及製作' },
    'subject_popularMusicProduction': { 'en': 'Popular Music Production', 'zh': '流行音樂製作' },
    'subject_takingChanceOnDance': { 'en': 'Taking a Chance on Dance', 'zh': '舞動人生' },
    'subject_essentialsTheatreArts': { 'en': 'The Essentials of Theatre Arts', 'zh': '劇場藝術導論' },

    // Media & Communication
    'subject_digitalMediaRadioProduction': { 'en': 'Digital Media and Radio Production', 'zh': '數碼媒體及電台廣播製作' },
    'subject_filmTransmedia': { 'en': 'Film and Transmedia/Film Production', 'zh': '電影及跨媒體/電影製作' },
    'subject_multimediaStorytelling': { 'en': 'Multimedia Storytelling', 'zh': '多媒體故事敘述' },
    'subject_prMultimediaCommunication': { 'en': 'PR and Multimedia Communication', 'zh': '公關及多媒體傳訊' },
    'subject_appliedLearningVocationalEnglishCommunication': { 'en': 'Applied Learning (Vocational English) - English Communication', 'zh': '應用學習（職業英語）- 英語傳意' },
    'subject_appliedLearningEnglishCommunication': { 'en': 'Applied Learning (Vocational English) - English Communication', 'zh': '應用學習（職業英語）- 英語傳意' },
    'subject_appliedLearningVocationalEnglishBusinessServices': { 'en': 'Applied Learning (Vocational English) - English for Business Services', 'zh': '應用學習（職業英語）- 商業服務英語' },
    'subject_appliedLearningEnglishForBusinessServices': { 'en': 'Applied Learning (Vocational English) - English for Business Services', 'zh': '應用學習（職業英語）- 商業服務英語' },
    'subject_appliedLearningVocationalEnglishServiceProfessionals': { 'en': 'Applied Learning (Vocational English) - English for Service Professionals', 'zh': '應用學習（職業英語）- 服務業專業英語' },
    'subject_appliedLearningEnglishForServiceProfessionals': { 'en': 'Applied Learning (Vocational English) - English for Service Professionals', 'zh': '應用學習（職業英語）- 服務業專業英語' },
    'subject_creativeEnglishCulturalTourism': { 'en': 'Creative English - Cultural Tourism', 'zh': '創意英語 - 文化旅遊' },
    'subject_creativeEnglishBizMedia': { 'en': 'Creative English - Biz and Media', 'zh': '創意英語 - 商業及媒體' },
    'subject_creativeEnglishBizAndMedia': { 'en': 'Creative English - Biz and Media', 'zh': '創意英語 - 商業及媒體' },
    'subject_creativeEnglishPrMarketing': { 'en': 'Creative English - PR and Marketing', 'zh': '創意英語 - 公關及市場推廣' },
    'subject_creativeEnglishPrAndMarketing': { 'en': 'Creative English - PR and Marketing', 'zh': '創意英語 - 公關及市場推廣' },
    'subject_practicalTranslationChinEng': { 'en': 'Practical Translation (CHIN-ENG)', 'zh': '實用翻譯（中英）' },
    'subject_practicalTranslation': { 'en': 'Practical Translation (CHIN-ENG)', 'zh': '實用翻譯（中英）' },
    'subject_appliedJapaneseJapaneseCulture': { 'en': 'Applied Japanese and Japanese Culture', 'zh': '應用日語及日本文化' },
    'subject_appliedJapaneseAndJapaneseCulture': { 'en': 'Applied Japanese and Japanese Culture', 'zh': '應用日語及日本文化' },
    'subject_everydayJapaneseJapaneseCulture': { 'en': 'Everyday Japanese and Japanese Culture', 'zh': '日常日語及日本文化' },
    'subject_everydayJapaneseAndJapaneseCulture': { 'en': 'Everyday Japanese and Japanese Culture', 'zh': '日常日語及日本文化' },
    'subject_koreanLanguageCulture': { 'en': 'Korean Language and Culture', 'zh': '韓語及韓國文化' },
    'subject_koreanLanguageAndCulture': { 'en': 'Korean Language and Culture', 'zh': '韓語及韓國文化' },

    // Business, Management & Law
    'subject_accountingInAction': { 'en': 'Accounting in Action', 'zh': '會計實務' },
    'subject_accountingForEBusiness': { 'en': 'Accounting for e-Business', 'zh': '電子商務會計' },
    'subject_aiInBusiness': { 'en': 'AI in Business', 'zh': '商業人工智能' },
    'subject_dataApplicationForBusiness': { 'en': 'Data Application for Business/AI Application in Business Data', 'zh': '商業數據應用/商業數據的人工智能應用' },
    'subject_dataApplicationForBusinessAiApplicationInBusinessData': { 'en': 'Data Application for Business/AI Application in Business Data', 'zh': '商業數據應用/商業數據的人工智能應用' },
    'subject_innovationEntrepreneurship': { 'en': 'Innovation and Entrepreneurship', 'zh': '創新及創業' },
    'subject_innovationAndEntrepreneurship': { 'en': 'Innovation and Entrepreneurship', 'zh': '創新及創業' },
    'subject_introductionToFintech': { 'en': 'Introduction to Fintech', 'zh': '金融科技導論' },
    'subject_kolMarketingGenerativeAi': { 'en': 'KOL Marketing and Generative AI', 'zh': 'KOL營銷及生成式人工智能' },
    'subject_kolMarketingAndGenerativeAi': { 'en': 'KOL Marketing and Generative AI', 'zh': 'KOL營銷及生成式人工智能' },
    'subject_marketingOnlinePromotion': { 'en': 'Marketing and Online Promotion', 'zh': '市場營銷及網上推廣' },
    'subject_marketingAndOnlinePromotion': { 'en': 'Marketing and Online Promotion', 'zh': '市場營銷及網上推廣' },
    'subject_modernLogisticsStudies': { 'en': 'Modern Logistics Studies', 'zh': '現代物流研究' },
    'subject_lawEnforcementHongKong': { 'en': 'Law Enforcement in Hong Kong', 'zh': '香港執法實務' },
    'subject_lawEnforcementInHongKong': { 'en': 'Law Enforcement in Hong Kong', 'zh': '香港執法實務' },
    // Category C - Other Languages
    'subject_french': { 'en': 'French Language', 'zh': '法語' },
    'subject_german': { 'en': 'German Language', 'zh': '德語' },
    'subject_japanese': { 'en': 'Japanese Language', 'zh': '日語' },
    'subject_korean': { 'en': 'Korean Language', 'zh': '韓語' },
    'subject_spanish': { 'en': 'Spanish Language', 'zh': '西班牙語' },
    'subject_urdu': { 'en': 'Urdu Language', 'zh': '烏爾都語' },


    // Services
    'subject_modernSoutheastAsianCuisine': { 'en': 'Modern Southeast Asian Cuisine', 'zh': '現代東南亞菜式' },
    'subject_patisserieCafeOperations': { 'en': 'Pâtisserie and Café Operations', 'zh': '西式糕餅及咖啡店營運' },
    'subject_westernCuisine': { 'en': 'Western Cuisine', 'zh': '西式廚藝' },
    'subject_airportPassengerTerminalOperations': { 'en': 'Airport Passenger Terminal Operations/Airport Operations and Services', 'zh': '機場客運大樓運作/機場運作及服務' },
    'subject_hospitalityServicesInPractice': { 'en': 'Hospitality Services in Practice', 'zh': '款接服務實務' },
    'subject_hotelOperations': { 'en': 'Hotel Operations', 'zh': '酒店營運' },
    'subject_childCareDevelopment': { 'en': 'Child Care and Development', 'zh': '幼兒照顧及發展' },
    'subject_childCareAndDevelopment': { 'en': 'Child Care and Development', 'zh': '幼兒照顧及發展' },
    'subject_childCareEducation': { 'en': 'Child Care and Education', 'zh': '幼兒照顧及教育' },
    'subject_childCareAndEducation': { 'en': 'Child Care and Education', 'zh': '幼兒照顧及教育' },
    'subject_fundamentalCosmetology': { 'en': 'Fundamental Cosmetology', 'zh': '基礎美容學' },
    'subject_gerontechServices': { 'en': 'Gerontech and Services', 'zh': '樂齡科技及服務' },

    // Applied Science
    'subject_foodTechnologyNutrition': { 'en': 'Food Technology and Nutrition', 'zh': '食品科技及營養學' },
    'subject_foundationChineseMedicine': { 'en': 'Foundation in Chinese Medicine', 'zh': '中醫學基礎' },
    'subject_healthCarePractice': { 'en': 'Health Care Practice', 'zh': '醫護實務' },
    'subject_medicalLaboratoryScience': { 'en': 'Medical Laboratory Science', 'zh': '醫務化驗科學' },
    'subject_petCareGrooming': { 'en': 'Pet Care and Grooming', 'zh': '寵物護理及美容' },
    'subject_rehabilitationCarePractice': { 'en': 'Rehabilitation Care Practice', 'zh': '復康護理實務' },
    'subject_appliedPsychology': { 'en': 'Applied Psychology', 'zh': '應用心理學' },
    'subject_practicalPsychology': { 'en': 'Practical Psychology', 'zh': '實用心理學' },
    'subject_exerciseFitnessCoaching': { 'en': 'Exercise and Fitness Coaching', 'zh': '運動及體適能教練' },
    'subject_exerciseScienceHealthFitness': { 'en': 'Exercise Science and Health Fitness', 'zh': '運動科學及健康體適能' },

    // Engineering & Production
    'subject_digitalConstruction': { 'en': 'Digital Construction', 'zh': '數碼建築' },
    'subject_electricalEnergyEngineering': { 'en': 'Electrical and Energy Engineering', 'zh': '電機及能源工程' },
    'subject_aiRobotics': { 'en': 'AI and Robotics', 'zh': '人工智能及機械人' },
    'subject_computerForensicTechnology': { 'en': 'Computer Forensic Technology', 'zh': '電腦鑑證科技' },
    'subject_cybersecurity': { 'en': 'Cybersecurity', 'zh': '網絡安全' },
    'subject_esportsTechnologyManagement': { 'en': 'eSports Technology and Management', 'zh': '電競科技及管理' },
    'subject_techBasics': { 'en': 'Tech Basics', 'zh': '科技基礎' },
    'subject_aviationStudies': { 'en': 'Aviation Studies', 'zh': '航空學' },
    'subject_railwayStudies': { 'en': 'Railway Studies', 'zh': '鐵路學' },

    // Recommended page - Form
    'profession': { 'en': 'What profession would you like to be?', 'zh': '你想從事什麼職業？' },
    'selectCareer': { 'en': 'Select career', 'zh': '選擇職業' },
    'engineer': { 'en': 'Engineer', 'zh': '工程師' },
    'doctor': { 'en': 'Doctor', 'zh': '醫生' },
    'teacher': { 'en': 'Teacher', 'zh': '教師' },
    'businessProfessional': { 'en': 'Business Professional', 'zh': '商業專才' },
    'designer': { 'en': 'Designer', 'zh': '設計師' },
    'lawyer': { 'en': 'Lawyer', 'zh': '律師' },
    'scientist': { 'en': 'Scientist', 'zh': '科學家' },
    'architect': { 'en': 'Architect', 'zh': '建築師' },

    'preferredUniversities': { 'en': 'Preferred Universities', 'zh': '首選大學' },
    'preferredDisciplines': { 'en': 'Preferred Disciplines', 'zh': '首選學科範疇' },
    'noPreference': { 'en': 'No preference', 'zh': '沒有偏好' },

    // Disciplines
    'engineering': { 'en': 'Engineering', 'zh': '工程學' },
    'artsHumanities': { 'en': 'Arts & Humanities', 'zh': '文學及人文科學' },
    'socialSciences': { 'en': 'Social Sciences', 'zh': '社會科學' },
    'business': { 'en': 'Business', 'zh': '商業' },
    'medicine': { 'en': 'Medicine', 'zh': '醫學' },
    'design': { 'en': 'Design', 'zh': '設計' },
    'law': { 'en': 'Law', 'zh': '法律' },
    'education': { 'en': 'Education', 'zh': '教育' },
    'science': { 'en': 'Science', 'zh': '科學' },
    'architecture': { 'en': 'Architecture', 'zh': '建築' },
    'mediaStudies': { 'en': 'Media Studies', 'zh': '媒體研究' },
    'interdisciplinary': { 'en': 'Interdisciplinary', 'zh': '跨學科' },

    // Interests
    'interests': { 'en': 'Your Interests / Hobbies', 'zh': '你的興趣/嗜好' },
    'problemSolving': { 'en': 'Problem Solving', 'zh': '解決問題' },
    'designing': { 'en': 'Designing', 'zh': '設計' },
    'traveling': { 'en': 'Traveling', 'zh': '旅遊' },
    'music': { 'en': 'Music', 'zh': '音樂' },
    'sports': { 'en': 'Sports', 'zh': '運動' },
    'cooking': { 'en': 'Cooking', 'zh': '烹飪' },
    'creativeArts': { 'en': 'Creative Arts', 'zh': '創意藝術' },
    'helpingPeople': { 'en': 'Helping People', 'zh': '助人' },
    'leadership': { 'en': 'Leadership', 'zh': '領導' },
    'outdoorActivities': { 'en': 'Outdoor Activities', 'zh': '戶外活動' },
    'writing': { 'en': 'Writing', 'zh': '寫作' },
    'technologyGadgets': { 'en': 'Technology & Gadgets', 'zh': '科技產品' },
    'publicSpeaking': { 'en': 'Public Speaking', 'zh': '演說' },
    'performingArts': { 'en': 'Performing Arts', 'zh': '表演藝術' },
    'volunteering': { 'en': 'Volunteering', 'zh': '義工服務' },
    'finance': { 'en': 'Finance', 'zh': '金融' },
    'politics': { 'en': 'Politics', 'zh': '政治' },
    'marketing': { 'en': 'Marketing', 'zh': '市場營銷' },
    'gaming': { 'en': 'Gaming', 'zh': '電子遊戲' },
    'otherHobbies': { 'en': 'Other hobbies', 'zh': '其他嗜好' },

    // Year & MBTI
    'currentYear': { 'en': 'Current Year of Study', 'zh': '現時就讀年級' },
    'selectYear': { 'en': 'Select year', 'zh': '選擇年級' },
    'secondary4': { 'en': 'Secondary 4', 'zh': '中四' },
    'secondary5': { 'en': 'Secondary 5', 'zh': '中五' },
    'secondary6': { 'en': 'Secondary 6', 'zh': '中六' },

    'mbtiType': { 'en': 'Your MBTI Personality Type', 'zh': '你的MBTI性格類型' },
    'selectPersonality': { 'en': 'Select personality', 'zh': '選擇性格類型' },

    'otherInfo': { 'en': 'Other Information (e.g. work preferences)', 'zh': '其他資料（例如工作喜好）' },
    'otherInfoPlaceholder': { 'en': 'e.g. I don\'t want an indoor job or to work in government.', 'zh': '例如：我不想做室內工作或在政府工作。' },

    // Buttons & Actions
    'getRecommendations': { 'en': 'Get Recommendations', 'zh': '獲取推薦' },
    'generatingRecommendations': { 'en': 'Generating AI Recommendations...', 'zh': '正在生成AI推薦...' },
    'aiScoringProgrammes': { 'en': 'AI is Scoring Programmes...', 'zh': 'AI正在評分課程...' },
    'analyzingProgrammes': { 'en': 'Our AI is analyzing each programme individually based on your profile.', 'zh': 'AI正根據你的個人檔案逐一分析每個課程。' },
    'calculatingMatches': { 'en': 'Calculating match scores for up to 30 programmes.', 'zh': '正在計算最多30個課程的配對分數。' },
    'pleaseWait': { 'en': 'This may take 1-2 minutes. Please wait...', 'zh': '這可能需要1-2分鐘。請稍候...' },

    // Results Display
    'aiMatchAnalysis': { 'en': 'AI Match Analysis', 'zh': 'AI配對分析' },
    'scoredByAi': { 'en': 'Scored by AI', 'zh': 'AI評分' },
    'rankedProgrammeMatches': { 'en': 'Ranked Programme Matches', 'zh': '課程配對排名' },
    'match': { 'en': 'Matched', 'zh': '配對度' },
    'probability': { 'en': 'Probability', 'zh': '機率' },
    's': { 'en': 's', 'zh': '' },

    // Programme Information
    'programmeNote': { 'en': 'Programme Note', 'zh': '課程備註' },
    'university': { 'en': 'University', 'zh': '大學' },
    'jupasCode': { 'en': 'Code', 'zh': '聯招編號' },
    'programme': { 'en': 'Programme', 'zh': '課程' },
    'faculty': { 'en': 'Faculty', 'zh': '學院' },
    'website': { 'en': 'Website', 'zh': '網站' },
    'visitProgrammeSite': { 'en': 'Visit Programme Site', 'zh': '瀏覽課程網站' },
    'jupasWebsite': { 'en': 'JUPAS Website', 'zh': '聯招網站' },
    'viewOnJupas': { 'en': 'JUPAS', 'zh': '瀏覽聯招' },
    'progWebsite': { 'en': 'Programme', 'zh': "課程網站" },
    'programmePeriod': { 'en': 'Programme Period', 'zh': '修讀年期' },
    'years': { 'en': 'years', 'zh': '年' },
    'interview': { 'en': 'Interview', 'zh': '面試' },
    'required': { 'en': 'Required', 'zh': '需要' },
    'notRequired': { 'en': 'Not Required', 'zh': '不需要' },
    'notSpecified': { 'en': 'Not specified', 'zh': '未指定' },

    // Recommendations
    'reasonsForRecommendations': { 'en': 'Reasons for Recommendations', 'zh': '推薦原因' },
    'whyGoodMatch': { 'en': 'Why It\'s a Good Match:', 'zh': '為何適合：' },
    'generalMatch': { 'en': 'General match based on available programmes', 'zh': '基於現有課程的一般配對' },
    'admissionLikelihood': { 'en': 'Admission Likelihood:', 'zh': '入學機會：' },
    'expectedScore': { 'en': 'Expected Score', 'zh': '預計分數' },
    'assessment': { 'en': 'Assessment', 'zh': '評估' },
    'goodMatch': { 'en': 'Good match', 'zh': '良好配對' },
    'moderateMatch': { 'en': 'Moderate match', 'zh': '一般配對' },

    // Programme Requirements
    'programmeRequirements': { 'en': 'Programme Requirements', 'zh': '課程要求' },
    'admissionScoresEstimated': { 'en': 'Admission Scores (Estimated):', 'zh': '入學分數（估計）：' },
    'year': { 'en': 'Year', 'zh': '年份' },
    'lowerQuartile': { 'en': 'LQ', 'zh': '下四分位' },
    'median': { 'en': 'Median', 'zh': '中位數' },
    'upperQuartile': { 'en': 'UQ', 'zh': '上四分位' },
    'subjectRequirements': { 'en': 'Subject Requirements', 'zh': '科目要求' },
    'weightings': { 'en': 'Weightings', 'zh': '比重' },

    // Cut-Off Marks
    'dseCutOffMarks': { 'en': 'DSE Cut-Off Marks (%)', 'zh': 'DSE 及格分數 (%)' },
    'collapseSection': { 'en': 'Collapse section', 'zh': '收起部分' },
    'expandSection': { 'en': 'Expand section', 'zh': '展開部分' },

    'like': { 'en': 'Like', 'zh': '喜愛' },

    // AI Analysis Summary
    'analysisComplete': { 'en': 'Analysis Complete', 'zh': '分析完成' },
    'analyzedProgrammes': { 'en': 'Analyzed', 'zh': '已分析' },
    'foundMatches': { 'en': 'and found', 'zh': '並找到' },
    'strongMatches': { 'en': 'strong matches', 'zh': '個強力配對' },
    'topMatchesOverview': { 'en': 'Top Matches Overview', 'zh': '頂級配對概覽' },
    'averageMatchScore': { 'en': 'Average Match Score', 'zh': '平均配對分數' },
    'bestMatch': { 'en': 'Best Match', 'zh': '最佳配對' },
    'at': { 'en': 'at', 'zh': '於' },
    'scoreRange': { 'en': 'Score Range', 'zh': '分數範圍' },
    'nextSteps': { 'en': 'Next Steps', 'zh': '下一步' },
    'reviewMatchReasons': { 'en': 'Review each programme\'s match reasons below', 'zh': '查看下方每個課程的配對原因' },
    'clickHeartIcon': { 'en': 'Click the heart icon to add programmes to your Favourites', 'zh': '點擊心形圖示以將課程加入最愛' },
    'visitWebsites': { 'en': 'Visit programme websites for more detailed information', 'zh': '瀏覽課程網站以獲取更詳細的資訊' },
    'considerScores': { 'en': 'Consider your academic scores when making final decisions', 'zh': '在做最終決定時考慮你的學業成績' },
    'matchScoresNote': { 'en': 'Match scores are based on your career goals, interests, disciplines, and personality type. Consider your actual academic performance when making final choices.', 'zh': '配對分數基於你的職業目標、興趣、學科和性格類型。在做最終選擇時請考慮你的實際學業成績。' },
    'note': { 'en': 'Note', 'zh': '注意' },
    'analyzing': { 'en': 'Analyzing', 'zh': '正在分析' },
    'programmeOf': { 'en': 'programme', 'zh': '課程' },
    'programmesAcross': { 'en': 'programmes across', 'zh': '個課程，涵蓋' },
    'universities': { 'en': 'universities', 'zh': '所大學' },
    'thisWillTake': { 'en': 'This may take 1-2 minutes.', 'zh': '這可能需要1-2分鐘。' },

    // Priorities page
    'myPriorities': { 'en': 'My Priorities', 'zh': '我的優先次序' },
    'dragToReorder': { 'en': 'Drag to reorder your programme priorities', 'zh': '拖曳以重新排列你的課程優先次序' },
    'noPriorities': { 'en': 'No programmes added to priorities yet', 'zh': '尚未加入任何課程到優先次序' },
    'addFromFavourites': { 'en': 'Add programmes from your Favourites', 'zh': '從最愛課程中加入課程' },
    'priority': { 'en': 'Priority', 'zh': '優先次序' },
    'remove': { 'en': 'Remove', 'zh': '移除' },

    // Favourites page
    'myFavourites': { 'en': 'My Favourites', 'zh': '我的最愛課程' },
    'noFavourites': { 'en': 'No favourite programmes yet', 'zh': '尚未收藏任何課程' },
    'browseRecommended': { 'en': 'Browse the Recommended page to find programmes', 'zh': '瀏覽推薦頁面以尋找課程' },
    'addToPriorities': { 'en': 'Add to Priorities', 'zh': '加入優先次序' },
    'removeFromFavourites': { 'en': 'Remove from Favourites', 'zh': '從最愛移除' },
    'myFavouriteProgrammes': { 'en': 'My Favourite Programmes', 'zh': '我的最愛課程' },
    'yourSavedProgrammes': { 'en': 'Your Saved Programmes', 'zh': '你儲存的課程' },
    'institution': { 'en': 'Institution', 'zh': '院校' },
    'actions': { 'en': 'Actions', 'zh': '操作' },
    'studyPeriod': { 'en': 'Study Period', 'zh': '修讀年期' },
    // 'notApplicable': {'en': 'N/A', 'zh': '不適用'},
    'notApplicable': { 'en': '-', 'zh': '-' },

    // Priorities page specific
    'jupasPriorities': { 'en': 'JUPAS Priorities', 'zh': 'JUPAS優先次序' },
    'exportSelections': { 'en': 'Export Selections', 'zh': '匯出選擇' },
    'yourJupasSelections': { 'en': 'Your JUPAS Selections', 'zh': '你的聯招選擇' },
    'programmeSelected': { 'en': 'programme(s) selected', 'zh': '個課程已選擇' },
    'noProgrammesSelected': { 'en': 'No programmes selected yet.', 'zh': '尚未選擇任何課程。' },
    'addFromRight': { 'en': 'Add programmes from your favourites on the right.', 'zh': '從右邊的最愛課程中加入課程。' },
    'availableFavourites': { 'en': 'Available Favourites', 'zh': '可用的最愛課程' },
    'programmeAvailable': { 'en': 'programme(s) available', 'zh': '個課程可用' },
    'noAvailableFavourites': { 'en': 'No available favourites.', 'zh': '沒有可用的最愛課程。' },
    'allAdded': { 'en': 'All your favourites have been added to selections.', 'zh': '你所有的最愛課程已加入選擇。' },
    'goToFavourites': { 'en': 'Go to Favourites page to add programmes first.', 'zh': '去最愛課程頁面先加入課程。' },
    'bandSummary': { 'en': 'Band Summary', 'zh': '組別摘要' },
    'overviewByBand': { 'en': 'Overview of your selections by band', 'zh': '按組別查看你的選擇概覽' },
    'band': { 'en': 'Band', 'zh': '組別' },
    'bandA': { 'en': 'Band A', 'zh': '組別 A' },
    'bandB': { 'en': 'Band B', 'zh': '組別 B' },
    'bandC': { 'en': 'Band C', 'zh': '組別 C' },

    // Additional labels
    'hideDetails': { 'en': 'Hide Details', 'zh': '隱藏詳情' },
    // 'showDetails': { 'en': 'Show Details', 'zh': '顯示詳情' },
    'showDetails': { 'en': '...', 'zh': '...' },
    'Requirements': { 'en': 'Requirements', 'zh': '入學要求' },
    'minimumRequirements': { 'en': 'Minimum Requirements', 'zh': '最低入學要求' },
    'formulaScores': { 'en': 'Formula Scores', 'zh': '計分公式' },
    'yourScores': { 'en': 'Your Scores', 'zh': '你的分數' },
    'yourScoreRange': { 'en': 'Your Score Range', 'zh': '你的分數範圍' },
    'erNotPassed': { 'en': 'ER not passed', 'zh': '未符合入學要求' },
    'minimumRequirementsNotBest5': { 'en': 'Minimum Requirements (Not Best 5 Calculation)', 'zh': '最低入學要求（非最佳五科計分）' },
    'best5SubjectsCalculation': { 'en': 'Best 5 Subjects Calculation:', 'zh': '最佳五科計分方法：' },
    'best5CalculationNote': { 'en': 'May include M1/M2 or Category C subject (whichever is higher)', 'zh': '可包括 M1/M2 或 丙類科目（以較高分數計算）' },
    'universityInformation': { 'en': 'University Information', 'zh': '大學資訊' },
    'moreInformation': { 'en': 'More Information', 'zh': '更多資訊' },
    'jupasNumber': { 'en': 'Code', 'zh': '聯招編號' },
    'period': { 'en': 'Period', 'zh': '修讀年期' },
    'programmeScoringFormula': { 'en': 'Programme Scoring Formula', 'zh': '課程計分方法' },
    'specialRequirements': { 'en': 'Special Requirements', 'zh': '特別要求' },
    'programmeWeighting': { 'en': 'Programme Weighting', 'zh': '課程比重' },
    'specificSubjectWeighting': { 'en': 'Specific Subject Weighting', 'zh': '特定科目比重' },
    'admissionScoresPast3Years': { 'en': 'Admission Scores (Past 3 Years)', 'zh': '歷年收生分數' },
    'admissionScores': { 'en': 'Admission Scores', 'zh': '歷年收生分數' },
    'historicScores': { 'en': 'Historic Scores', 'zh': '歷史分數' },
    'newProgrammeNoPastScores': { 'en': 'No past admission scores', 'zh': '沒有過往收生分數' },
    'newProgramme': { 'en': 'New', 'zh': '新' },
    'requirements': { 'en': 'Requirements', 'zh': '收生要求' },
    'entryRequirements': { 'en': 'Entry Requirements', 'zh': '入學要求' },
    'standardDseRequirements': { 'en': 'Standard DSE requirements', 'zh': '標準文憑試要求' },
    'best5Subjects': { 'en': 'Best 5 subjects', 'zh': '最佳五科' },
    'scoreBreakdown': { 'en': 'Score Breakdown', 'zh': '分數細分' },
    'english': { 'en': 'English', 'zh': '英文' },
    'chinese': { 'en': 'Chinese', 'zh': '中文' },
    'mathematicsSubject': { 'en': 'Mathematics', 'zh': '數學' },
    'electivesRanked': { 'en': 'Electives Ranked:', 'zh': '選修科目排名：' },
    'totalScore': { 'en': 'Total Score', 'zh': '總分' },
    'noProgrammesFoundFilter': { 'en': 'No programmes found for this filter.', 'zh': '未找到符合條件的課程' },
    'manageSavedProgrammes': { 'en': 'Manage your saved programmes', 'zh': '管理你儲存的課程' },
    'total': { 'en': 'total', 'zh': '個' },
    'clickToViewDetails': { 'en': 'Click on a programme to view details or remove it from your favourites', 'zh': '點擊課程以查看詳情或從最愛移除' },
    'constructJupasSelections': { 'en': 'Construct your JUPAS band selections from your favourite programmes', 'zh': '從你的最愛課程中構建你的聯招組別選擇' },
    'selectedCount': { 'en': 'selected', 'zh': '已選擇' },
    'maxSelectionsReached': { 'en': 'Maximum 20 selections reached', 'zh': '已達到20個選擇的上限' },
    'maxSelectionsWarning': { 'en': '⚠️ Maximum 20 selections reached. Remove existing selections to add other programmes.', 'zh': '⚠️ 已達到20個選擇的上限。請移除現有選擇以添加其他課程。' },
    'availableCount': { 'en': 'available', 'zh': '可用' },
    'programmesLabel': { 'en': 'programme(s)', 'zh': '個課程' },
    'scienceCategory': { 'en': 'Science', 'zh': '科學' },
    'mathematicsM1M2': { 'en': 'Mathematics (M1/M2)', 'zh': '數學 (M1/M2)' },
    'societyCategory': { 'en': 'Society', 'zh': '社會' },
    'artsCategory': { 'en': 'Arts', 'zh': '藝術' },
    'sportsCategory': { 'en': 'Sports', 'zh': '體育' },
    'languagesCategory': { 'en': 'Languages', 'zh': '語言' },
    'categoryASubjectsOrM1M2': { 'en': 'Category A Subjects or M1/M2', 'zh': '甲類科目或M1/M2' },
    'categoryCSubjects': { 'en': 'Category C Subjects', 'zh': '丙類科目或M1/M2' },

    // Home page specific
    'jupasScoreCalculator': { 'en': 'JUPAS Score Calculator', 'zh': 'JUPAS 分數計算器' },
    'enterMaxExpectedDescription': { 'en': 'Enter your maximum expected DSE grades to see eligible programmes', 'zh': '輸入你的最高預期DSE成績以查看符合資格的課程' },
    'enterMaxExpectedOnlyDescription': { 'en': 'Enter your maximum expected grades (only max expected is required, current and minimum are ignored)', 'zh': '輸入你的最高預期成績（只需填寫最高預期，無需填寫現時及最低成績）' },
    'noSubjectsAdded': { 'en': 'No subjects added. Click "Add Subject" to start.', 'zh': '未新增科目。點擊「新增科目」開始。' },
    'selectSubject': { 'en': 'Select subject', 'zh': '選擇科目' },
    'currentGrade': { 'en': 'Current Grade', 'zh': '現時成績' },
    'grade': { 'en': 'Grade', 'zh': '成績' },
    'minGrade': { 'en': 'Min Grade', 'zh': '最低成績' },
    'maxGrade': { 'en': 'Max Grade', 'zh': '最高成績' },
    'calculating': { 'en': 'Calculating...', 'zh': '計算中...' },
    'calculateScores': { 'en': 'Calculate Scores', 'zh': '計算分數' },
    'fillMaxExpectedWarning': { 'en': 'Please fill in Max Expected grade for at least one subject', 'zh': '請至少為一個科目填寫最高預期成績' },
    'showingProgrammes': { 'en': 'Showing', 'zh': '顯示' },
    'current': { 'en': 'Score', 'zh': '分數' },
    'lowerQuartile2025': { 'en': '2025 LQ', 'zh': '2025 下四分位數' },
    'median2025': { 'en': '2025 Median', 'zh': '2025 中位數' },
    'myScore': { 'en': 'My Score', 'zh': '我的分數' },
    'historicalScores': { 'en': 'Historical Scores', 'zh': '歷史分數' },
    'subjectBreakdown': { 'en': 'Subject Breakdown', 'zh': '科目細分' },
    'scoreAnalysis': { 'en': 'Score Analysis', 'zh': '分數分析' },
    'noProgrammesFound': { 'en': 'No programmes found for this filter.', 'zh': '此篩選條件下未找到課程。' },

    // Recommended page
    'stopAnalysis': { 'en': 'Stop Analysis', 'zh': '停止分析' },
    'recommendedBadge': { 'en': 'Recommended', 'zh': '推薦' },

    // Elective subjects selector
    'selected': { 'en': 'Selected', 'zh': '已選' },
    'scienceCategoryA': { 'en': 'Science (Category A Subjects)', 'zh': '科學 (Category A Subjects)' },
    'mathematicsM1M2Label': { 'en': 'Mathematics (M1/M2)', 'zh': '數學 (M1/M2)' },
    'societyLabel': { 'en': 'Society', 'zh': '社會' },
    'otherLanguagesCategoryC': { 'en': 'Other Languages (Category C Subjects)', 'zh': '其他語言 (Category C Subjects)' },

    'quota': { 'en': 'Quota', 'zh': '名額' },
    'recommendationRate': { 'en': 'Sorting Indicator', 'zh': '排列指標' },
    'favourite': { 'en': 'Favourite', 'zh': '喜愛' },
    'tableViewAvailableDesktop': { 'en': 'Table view available for screens ≥ 1024px', 'zh': '表格檢視適用於螢幕寬度 ≥ 1024px' },

    'missingElective': { 'en': 'Missing Elective', 'zh': '欠缺選修科' },

    'yourMinScore': { 'en': 'Your Min Score', 'zh': '你的最低分數' },
    'yourMaxScore': { 'en': 'Your Max Score', 'zh': '你的最高分數' },
    'currentScore': { 'en': 'Score', 'zh': '分數' },
    'minScore': { 'en': 'Min', 'zh': '最低' },
    'maxScore': { 'en': 'Max', 'zh': '最高' },
    'score': { 'en': 'Score', 'zh': '分數' },

    'minExpected': { 'en': 'Min.', 'zh': '最低成績' },
    'maxExpected': { 'en': 'Max.', 'zh': '最高成績' },

    // Passing rate phrases
    'passingPhrase_newProgramme': { 'en': 'New Programme', 'zh': '新課程' },
    'passingPhrase_extremelySafe': { 'en': 'Safe', 'zh': '非常安全' },
    'passingPhrase_veryStrong': { 'en': 'Strong', 'zh': '很強' },
    'passingPhrase_stronglyRecommended': { 'en': 'Recommended', 'zh': '強烈推薦' },
    'passingPhrase_solidPass': { 'en': 'Pass', 'zh': '穩健' },
    'passingPhrase_moderatelySafe': { 'en': 'Moderate', 'zh': '中等安全' },
    'passingPhrase_marginal': { 'en': 'Marginal', 'zh': '邊緣' },
    'passingPhrase_slightlyAbove': { 'en': 'Slightly above', 'zh': '略高於' },
    'passingPhrase_justAbove': { 'en': 'Just above', 'zh': '剛好超過' },
    'passingPhrase_atRisk': { 'en': 'At risk', 'zh': '有風險' },
    'passingPhrase_wellBelow': { 'en': 'Well below', 'zh': '遠低於' },

    'specificWeights': { 'en': 'Specific Weights', 'zh': '特定比重' },
    'scoreDistribution': { 'en': 'Score Distribution', 'zh': '分數分布' },

    // Activity log
    'activityLog': { 'en': 'Activity Log', 'zh': '活動記錄' },
    'activityLogDescription': { 'en': 'Your recent selections and actions, synced with your account.', 'zh': '你近期的選擇和操作，已與你的帳戶同步。' },
    'activityLogEmpty': { 'en': 'No activity recorded yet.', 'zh': '尚未有活動記錄。' },
    'activityLogCount': { 'en': '{count} entries', 'zh': '共 {count} 條記錄' },
    'refresh': { 'en': 'Refresh', 'zh': '重新整理' },
}

export default LABELS;

export type LabelKey = keyof typeof LABELS;